import { observer } from "mobx-react"
import React, { useState, useRef } from "react"
import "../../styles/Header/talkToExpertModal.less"
import CalculatorStore from "../../Configs/Store/calculator"
import { Column } from "@ant-design/plots"

const ChartModal = observer((props) => {
  const [isActive, setActive] = useState(false)
  const ref = useRef(null)
  window.data = CalculatorStore.chartOptions

  const formatNumber = (number) => {
    const SI_SYMBOL = ["", "K", "M", "B", "T", "P", "E"]
    const tier = Math.log10(Math.abs(number)) / 3 | 0
    if (tier == 0) return number
    const suffix = SI_SYMBOL[tier]
    const scale = Math.pow(10, tier * 3)
    const scaled = Math.floor(number / scale)
    const formatted = scaled.toString() + suffix
    return `₹ ${formatted}`
  }

  const addCommasToNumber = (number) => {
    if (number === 0) return 0
    const numberString = number.toString()
    const integerPart = numberString.slice(0, -3)
    const decimalPart = numberString.slice(-3)
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{2})+(?!\d))/g, ',')
    const formattedNumber = formattedIntegerPart + ',' + decimalPart
    return `₹${formattedNumber}`
  }

  const config = {
    data: props.data,
    xField: "Age",
    yField: "Amount",
    color: ["#094b7f", "rgb(222,99,53)"],
    yAxis: {
      label: {
        formatter: (v) => formatNumber(v),
        style: {
          fontFamily: "Mulish",
          fill: "rgb(102, 102, 102)",
          opacity: "1"
        }
      },
    },
    xAxis: {
      label: {
        style: {
          fontFamily: "Mulish",
          fill: "rgb(102, 102, 102)",
          opacity: "1"
        }
      },
    },
    seriesField: "type",
    padding: 45,
    annotations: [
      {
        type: "text",
        position: ["50%", "112%"],
        content: "Age",
        style: {
          fill: "rgb(102, 102, 102)",
          fontFamily: "Mulish"
        },
      },
    ],
    legend: {
      layout: "horizontal",
      position: "top-right",
      itemName: {
        style: {
          fill: 'rgb(51, 51, 51)',
          fontFamily: "Mulish",
          fontWeight: "bold"
        },
      },
      marker: {
        symbol: 'circle',
      },
    },
    tooltip: {
      formatter: (data) => {
        return { name: data.type, value: addCommasToNumber(data.Amount) }
      }
    },
    isGroup: true,
  }

  const toggleClass = () => {
    setTimeout(() => {
      setActive(!isActive)
    }, 300)
  }

  return (
    <>
      <div className="common-modal-wrap">
        <div style={{ opacity: "1" }} className="modal fade" id="yourGraphModal" tabIndex="-1" role="dialog" aria-labelledby="yourGraphModalTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div style={{ height: "auto" }} className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="common-modal-body">
                  <div className="row pb-5 collapsible-row">
                    <div className={isActive ? "col collapsible-col closed" : "col collapsible-col opened"}>
                      <div
                        className="graph-wrapper"
                        style={{
                          width: "96%",
                          margin: "auto",
                        }}
                        ref={ref}
                      >
                        <div className="graph-blk" id="graph-blk" style={{ height: "auto" }}>
                          <div
                            style={{
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "20px",
                              fontFamily: "Mulish",
                              fill: "rgb(30, 30, 30)",
                              marginBottom: "12px",
                            }}
                          >
                            Savings vs Post-Retirement Expenses
                          </div>
                          <Column {...config} />
                        </div>
                      </div>
                    </div>
                    <div className="col-auto px-0 style-hide-mob">
                      <div className={isActive ? "collapsible-div open" : "collapsible-div closed"}>
                        <p className="collapsible-bttn">
                          <span className="txt st" onClick={toggleClass}>
                            Know more about the graph
                          </span>
                          <span className="togglr st" onClick={toggleClass}>
                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                          </span>
                        </p>
                        <div className="collapsible-body">
                          <p className="ttl">Know more about the graph</p>
                          <p className="para">
                            The graph represents the cash flow pre and post retirement. We can clearly see how your savings will start depleting post retirement due to the monthly expenses. This
                            happens because of absence of a regular source of income. Your current savings will last till {CalculatorStore.surviveTillAge} Years of Age.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
})

export default ChartModal
